import "./array";
import { Gydra } from "./gydra";
export * from "./gydra";
export * from "./synth";
export { setFunction } from "./glsl";
export * from "./module";
export * from "./output";
export * from "./renderer";
export * from "./sandbox";
export * from "./sequence";
export * from "./shader/shader";
export * from "./source";
export * from "./synth";
export * from "./texture";
export * from "./utils";
const createGydra = (settings = {}) => new Gydra(settings);
createGydra.functions = Gydra.functions;
createGydra.version = Gydra.version;
export default createGydra;
